import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import {
  clearSectionQuestions,
  getSectionQuestions,
  saveAnswers,
} from '../../actions/form';

import {
  Loader,
} from '../base';

import SectionedForm from '../SectionedForm/SectionedForm';

class JobSection extends Component {
  state = {
    isSubmitting: false,
  }

  componentDidMount() {
    try {
      // fetch questions from BE
      this.props.actions.getFormSections(this.props.job.id, this.props.formName);
    } catch (e) {

    }
  }

  componentWillUnmount() {
    this.props.actions.clearSectionQuestions(this.props.formName);
  }

  submitForm = (answers, hasTestAssessmentChanged) =>
    this.props.actions.saveAnswers(this.props.job.id, this.props.formName, answers, hasTestAssessmentChanged)

  render() {
    const { formSections, isSubmitting, formName, name, updateChangedSections, job, user, formTranslations } = this.props;
    const section = formSections && formSections[name];

    return (
      section
      ? <SectionedForm
          formName={formName}
          updateChangedSections={updateChangedSections}
          shouldGetFormSections={true}
          formSections={section}
          onSubmit={this.submitForm}
          isSubmitting={isSubmitting}
          job={job}
          user={user}
          formTranslations={formTranslations}
          hasActionMode
          updateChangedForms={this.props.updateChangedForms}
          saveAnswers={this.submitForm}
        />
      : isSubmitting ? <Loader color='secondary'/> : <div>No data fetched.</div>
    )
  }
}

const mapStateToProps = state => ({
  formSections: state.singleJob.sections,
  isSubmitting: state.form.isSubmitting,
})

const mapDispatchToProps = dispatch => ({
  actions: {
    clearSectionQuestions: bindActionCreators(clearSectionQuestions, dispatch),
    getFormSections: bindActionCreators(getSectionQuestions, dispatch),
    saveAnswers: bindActionCreators(saveAnswers, dispatch),
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(JobSection);



// WEBPACK FOOTER //
// ./src/components/JobSection/JobSection.js